/**
 * Polyfills for older browsers (Safari 13-14, etc.)
 * Load this before using streaming features like client-zip
 */

let polyfillLoaded = false;
let polyfillPromise: Promise<boolean> | null = null;

export const ensureStreamSupport = async (): Promise<boolean> => {
  // Check if ReadableStream is already available
  if ('ReadableStream' in window && polyfillLoaded) {
    return true;
  }

  // If polyfill is already being loaded, wait for it
  if (polyfillPromise) {
    return polyfillPromise;
  }

  // Check if native ReadableStream exists
  if ('ReadableStream' in window) {
    polyfillLoaded = true;
    return true;
  }

  // Load polyfill only once
  polyfillPromise = (async () => {
    try {
      const polyfill: any = await import('web-streams-polyfill');
      // @ts-ignore - Polyfill assignment to window
      window.ReadableStream = polyfill.ReadableStream;
      // @ts-ignore - Polyfill assignment to window
      window.WritableStream = polyfill.WritableStream;
      // @ts-ignore - Polyfill assignment to window
      window.TransformStream = polyfill.TransformStream;
      polyfillLoaded = true;
      return true;
    } catch (error) {
      console.warn('Failed to load streams polyfill:', error);
      return false;
    }
  })();

  return polyfillPromise;
};
